import pembentukan1Andrew27 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Andrew Su-27 Large.jpeg";
import pembentukan1Cinta7 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Cinta_7 Large.jpeg";
import pembentukan1Kelvin073 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kelvin Kurniawan_073 Large.jpeg";
import pembentukan1Thirza31 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1-Thirza-31 Large.jpeg";
import pembentukan1Kenzie19 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kenzie Andhika Theodorus Suhanto_19 Large.jpeg";
import pembentukan1Ravalen43 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Ravalen Virginia_43 Large.jpeg";
import pembentukan1Johan31 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Johan Felix_31 Large.jpeg";
import pembentukan1Stevan14 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Stevan Antonius-14 Large.jpeg";
import pembentukan1Cinta26 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Cinta_26 Large.jpeg";
import pembentukan1Johan56 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Johan Felix_56 Large.jpeg";
import pembentukan1Kenzie62 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kenzie Andhika Theodorus Suhanto_62 Large.jpeg";
import pembentukan1Devin67 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Devin Edsel_67 Large.jpeg";
import pembentukan1Johan28 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan-Hari-1_Johan-Felix_28-Large.jpeg";
import pembentukan1Thirza25 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1-Thirza-25 Large.jpeg";
import pembentukan1Bernice18 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1-Bernice-18 Large.jpeg";
import pembentukan1Kelvin042 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kelvin Kurniawan_042 Large.jpeg";
import pembentukan1Andrew46 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Andrew Su-46 Large.jpeg";
import pembentukan1Kia38 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kia_38 Large.jpeg";
import pembentukan1Devin33 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Devin Edsel_33 Large.jpeg";
import pembentukan1Kia36 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Kia_36 Large.jpeg";
import pembentukan1Stevan53 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Stevan Antonius-53 Large.jpeg";
import pembentukan1Ravalen69 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Ravalen Virginia_69 Large.jpeg";
import pembentukan1Andrew44 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1_Andrew Su-44 Large.jpeg";
import pembentukan1Bernice51 from "../../Assets/Pembentukan-Hari-1-Revisi/Pembentukan Hari 1-Bernice-51 Large.jpeg";

const hariPembentukan1 = [
  { id: 1, img: pembentukan1Andrew27 },
  { id: 2, img: pembentukan1Cinta7 },
  { id: 3, img: pembentukan1Kelvin073 },
  { id: 4, img: pembentukan1Thirza31 },
  { id: 5, img: pembentukan1Kenzie19 },
  { id: 6, img: pembentukan1Ravalen43 },
  { id: 7, img: pembentukan1Johan31 },
  { id: 8, img: pembentukan1Stevan14 },
  { id: 9, img: pembentukan1Cinta26 },
  { id: 10, img: pembentukan1Johan56 },
  { id: 11, img: pembentukan1Kenzie62 },
  { id: 12, img: pembentukan1Devin67 },
  { id: 13, img: pembentukan1Johan28 },
  { id: 14, img: pembentukan1Thirza25 },
  { id: 15, img: pembentukan1Bernice18 },
  { id: 16, img: pembentukan1Kelvin042 },
  { id: 17, img: pembentukan1Andrew46 },
  { id: 18, img: pembentukan1Kia38 },
  { id: 19, img: pembentukan1Devin33 },
  { id: 20, img: pembentukan1Kia36 },
  { id: 21, img: pembentukan1Stevan53 },
  { id: 22, img: pembentukan1Ravalen69 },
  { id: 23, img: pembentukan1Andrew44 },
  { id: 24, img: pembentukan1Bernice51 }
];

export default hariPembentukan1;